module.exports = __webpack_public_path__ + "static/media/night_flight_header.7e0d87c5.jpg";